const { Type } = require('@sinclair/typebox');
const Blockly = require('blockly');
const { merge } = require('lodash');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');

// this would be a circular reference right now....
// const filterTypes = require('.');

const _p = {
    filterTypes: {}
};

const TOOLTIP =
    "Allows filtering a given control's content records to those where ONE nested list entry matches ALL nested filters.";

function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    blocklyBlock.setTooltip(TOOLTIP);
    //set inputs to be arranged horizontally (this is the default)
    //Meaning each (dummy)input continues on the top line followed by  the access modifiers
    blocklyBlock.setInputsInline(false);
    line1OfInputs.appendField(new Blockly.FieldTextInput('inventory'), 'propertyName');

    //Statement inputs ALWAYS go on their own line.
    blocklyBlock.appendStatementInput('filters').setCheck(['filter']).appendField('Matches all of these filters:');
}

function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties(['propertyName']);
    //nested blocks in the statements are added automatically by blockly
    return code;
}

/** Builds the filter metadata fragment for the NestedListEntry block. */
function asDataDictionary(hNode, context) {
    const { propertyName } = hNode;
    let [childDefinedSubDataDictionary, childDefinedPartialTypeDefinition] = hNode.children.reduce(
        (soFar, child) => {
            const [childSubDD = {}, childPartial = {}] =
                moduleRegistration.getHNodeType('filters', child.hNodeType)?.asDataDictionary?.(child, context) || [];
            return [merge(soFar[0], childSubDD), Object.assign(soFar[1], childPartial)];
        },
        [{}, {}]
    );

    // Wrap child definitions in an object schema that becomes the array's items schema
    const requiredChildKeys = Object.keys(childDefinedPartialTypeDefinition || {});
    const itemSchema = Type.Object(
        childDefinedPartialTypeDefinition,
        {
            title: '0',
            'x-dataType': 'object',
            additionalProperties: true,
            required: requiredChildKeys
        }
    );
    const partialTypeDefinition = {
        [propertyName]: Type.Array(itemSchema, {
            'x-dataType': 'array',
            'x-propertyName': propertyName
        })
    };

    //And the given foreignKey exists on the parent object.
    return [childDefinedSubDataDictionary, partialTypeDefinition];
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode, asDataDictionary, _private: _p };
